import {AbstractEvent} from "@/modules/base/events";
import {Match} from "@/modules/match/entity";
import {LanesType} from "@/modules/match/services/live-match-handlers/LaneBasedGoalsHandler";

export class AfterMatchLaneCalculatedEvent extends AbstractEvent {
  constructor(
    public match: Match,
    public lanes: LanesType,
  ) {
    super();
  }
}